import React from 'react';
import { Box } from '@mui/material';
import { SignIn } from '@clerk/clerk-react';

/**
 * AUTH-4 — hosted Clerk sign-in (path routing under /sign-in/*). The social
 * providers (Google) and email/password are enabled in the Clerk dashboard, not
 * here (ADR-007). Only mounted when REACT_APP_AUTH_ENABLED is on (see App.js).
 */
export default function SignInPage() {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
            <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" />
        </Box>
    );
}
